import React from "react";
import { Container, Divider, Button } from "semantic-ui-react";

import RecipentList from "../recipients/RecipientList";
import SendTestEmail from "./SendTestEmail";

const AddRecipient = props => {
  const { project, selectedCount } = props;
  
  return (
    <div>
      <Container style={{ marginTop: 60 }}>
        <h2 style={{ marginBottom: 20 }}>Add Recipent</h2>
        <div style={{ marginBottom: 50 }}>
          <h3>{project.title}</h3>
          <div>
            {project.subject}
            <Button
              onClick={props.sendEmail}
              style={{ marginTop: -15 }}
              color="green"
              floated="right"
              disabled={selectedCount < 1}
            >
              Send Email
            </Button>
            <Button
              onClick={props.saveDraft}
              style={{ marginTop: -15 }}
              color="orange"
              floated="right"
            >
              Save Draft
            </Button>
            <Button
              style={{ marginTop: -15 }}
              floated="right"
              onClick={props.loadTemplate}
            >
              Back
            </Button>
          </div>
        </div>
        <SendTestEmail {...props}/>
        <Divider />
        <RecipentList {...props} />
      </Container>
    </div>
  );
};

export default AddRecipient;
